module.exports = __webpack_public_path__ + "img/logo_prato.e0c009eb.png";